const authenticationActions = {
  AUTHENTICATION_SUCCESS: 'AUTHENTICATION_SUCCESS',
  AUTHENTICATION_EXTERNAL_SUCCESS: 'AUTHENTICATION_EXTERNAL_SUCCESS',

  NEW_USER_REQUEST: 'NEW_USER_REQUEST',
  NEW_USER_SUCCESS: 'NEW_USER_SUCCESS',

  RESET_PASSWORD_REQUEST_SUCCESS: 'RESET_PASSWORD_REQUEST_SUCCESS',

  LOGOUT: 'LOGOUT',
};

export default authenticationActions;
